<template>
  <section class="indexPage">
    <main class="indexPage__main">
      <FormSignIn />
    </main>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import FormSignIn from '@/components/component/form-sign-in'
// import useAuth from '@/useAuth'

export default {
  name: 'IndexPage',
  components: {
    FormSignIn
  },
  computed: {
    ...mapState({
      isUserLoggedIn: state => state.isUserLoggedIn
    })
  },
  created() {
    this.setTheme('dark')
    this.setShowHeader(true)
    document.body.style.removeProperty('height')
  },
  mounted() {
    // if (useAuth().isLoggedIn()) {
    //   this.$router.push('/press')
    // }
  },
  methods: {
    ...mapMutations({
      setTheme: 'setTheme',
      setShowHeader: 'setShowHeader'
    })
  }
}
</script>

<style lang="scss">
.indexPage {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;

  &,
  &__main {
    display: flex;
    flex-direction: column;
    flex: 1 1 calc(100vh - 96px);

    @media screen and (min-width: 768px) {
      flex: 1 1 calc(100vh - 66px);
    }
  }

  &__main {
    background-color: var(--white);
    color: var(--black);
    padding-top: 66px;
  }

  &__footer {
    background-color: var(--white) !important;
    color: var(--black) !important;
  }
}
</style>
